/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetConversationQueryResponse, GetConversationPathParams, GetConversation401, GetConversation500 } from "../../types/chatController/GetConversation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetConversationUrl(organizationId: GetConversationPathParams["organizationId"], conversationId: GetConversationPathParams["conversationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/chat/conversations/${conversationId}` as const }
  return res
}

/**
 * @summary Get a single conversation with messages
 * {@link /api/organizations/:organizationId/chat/conversations/:conversationId}
 */
export async function getConversation(organizationId: GetConversationPathParams["organizationId"], conversationId: GetConversationPathParams["conversationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetConversationQueryResponse, ResponseErrorConfig<GetConversation401 | GetConversation500>, unknown>({ method : "GET", url : getGetConversationUrl(organizationId, conversationId).url.toString(), ... requestConfig })
  return res.data
}